/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nowuntil1Inputs */



/**
* | output |
* | --- |
* | "Now until" |
*
* @param {Nowuntil1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nowuntil1 = /** @type {((inputs?: Nowuntil1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nowuntil1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Now until")
	return /** @type {LocalizedString} */ ("Jetzt bis")
});
export { nowuntil1 as "nowUntil" }